module.exports = __webpack_public_path__ + "img/faq.88dab136.svg";